import {
  pupPlayPending, pupTargetChosen, pupPlayCleared, pupCardsRevealed, pupCardModified,
} from './pupSlice';

// Pure mapping from the public WebSocket contract to feature-owned Redux actions. Visual and
// audio side effects stay in socketMiddleware; Pup state transitions are testable without STOMP.
export const translatePupRoomEvent = (roomId, event) => {
  const payload = { roomId, ...(event?.payload || {}) };
  switch (event?.type) {
    case 'PUP_PLAY_PENDING': return [pupPlayPending(payload)];
    case 'PUP_TARGET_CHOSEN': return [pupTargetChosen(payload)];
    case 'PUP_PLAY_RESOLVED':
    case 'PUP_PLAY_CANCELLED': return [pupPlayCleared({ roomId, playId: payload.playId })];
    case 'PUP_CARDS_REVEALED':
      return payload.kind === 'guess' ? [] : [pupCardsRevealed(payload)];
    case 'PUP_CARD_MODIFIED':
      return [pupCardModified(payload)];
    default: return [];
  }
};
